import Route from 'cio/routes/base';
import { action } from '@ember/object';
import Transition from '@ember/routing/-private/transition';
import ObjectModel from 'cio/models/object';
import { inject as service } from '@ember/service';
import { oneWay } from '@ember/object/computed';
import RouterService from '@ember/routing/router-service';
import DS from 'ember-data';
import ObjectTypeModel from 'cio/models/object-type';

export default class PersonRoute extends Route {
  @service router!: RouterService;
  @service store!: DS.Store;

  crumb() {
    return {
      name: oneWay('model.name') as unknown as string,
      path: this.routeName,
      model: this.modelFor('object'),
    };
  }

  model() {
    let { object_id } = this.paramsFor('object') as Record<string, string>;
    let objectType = this.modelFor('objects.type') as ObjectTypeModel;

    return this.store.findRecord('object', object_id, {
      adapterOptions: {
        objectTypeId: objectType.id,
      },
    });
  }

  // Currently users access person pages using the external id of a customer for the id param.
  // In the future, however, person pages will use the internal id as the id param. If they access a
  // person page by the external id because it was bookmarked or a link was shared, then we should
  // redirect them to the person page using the internal id instead.
  redirect(model: ObjectModel, transition: Transition) {
    let { object_id } = this.paramsFor('object') as Record<string, string>;

    if (object_id !== model.id) {
      // We need to construct an array of all param IDs required for the target
      // route, keeping in mind that the target route may be a nested child.
      // For a more specific example, a journey child route needs both the
      // object id and the journey id passed in. We need to replace the object
      // id with the internal one, but keep the journey ID as is.

      // Filter out object_id, if it exists (inspecting the RouteInfo objects
      // shows me that, for some reason, object_id isn't included in the params
      // array. I'm guessing that's because of resetNamespace.
      // Just in case, we'll filter it out (we're always adding the object ID at
      // the start anyway).
      let targetParamValues = transition.to?.params ?? {};
      let targetParamNames = (transition.to?.paramNames ?? []).filter((p) => p !== 'object_id');
      let paramValues = [model.id, ...targetParamNames.map((paramName) => targetParamValues[paramName])].compact();

      // @ts-ignore transitionTo typing doesn't support destructured argument
      this.router.transitionTo(transition.to.name, ...paramValues);
    }
  }

  @action
  refreshModel() {
    return this.refresh();
  }
}
